import React, { useEffect, useState } from 'react';
import ExperimentCanvas from 'components/plateviewer/experiment/ExperimentCanvas';
import {
  GetPlatePadding,
  GetUnifiedExperimentCanvasHeight,
  SetRectCounter,
  DisplayModes,
  GetDisplayMode,
  SetDisplayMode,
  InitWellRects,
  isNullOrUndefined,
} from 'utils/Global';
import 'components/customComponents/customTab.scss';
import './experiment.scss';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import useProductEdition from 'CustomHooks/useProductEdition';
import { ELoadingTypes } from 'enums/ELoadingTypes';
import ReactTooltip from 'react-tooltip';
import { setPlateSize as setPlateSizeRedux } from 'redux/reducers/experimentDataReducer';
import { cloneDeep } from 'lodash';
import { EProductEditions } from 'enums/EProductEditions';
import { LoadingModal } from 'components/modal';
import { getPlateSize } from 'utils/ExperimentUtils';
import useRMLite from 'CustomHooks/useRMLite';
import { getExperimentInfoIsDirty } from 'components/customComponents/Experiment/ImagingSchedule/ImagingScheduleData';
import { usePlatesImagesStructureData, usePlateSize } from 'components/Experiment/hooks';
import { WIDTH_MAIN_DIV, isScoringFeatureEnabled } from 'components/Experiment/constants';
import { useParams } from 'react-router-dom';

let experimentData: ExperimentDtoClient;
let recentExpID = 0;
const ExpTabs = {
  Canvas: 'Canvas',
  Drop: 'Drop',
};

const selectedTab = ExpTabs.Canvas;
let view = 'Image';
let loadingDetails: string[] = [];
const canvasHeight = GetUnifiedExperimentCanvasHeight();
function Experiment(props) {
  const { id: paramsId } = useParams<{ id: string }>();
  const expid: number = parseInt(paramsId);
  const [refresh, setRefresh] = useState(false);
  const [redrawCanvasDuetoExpInfoDirtyState, setRedrawCanvasDuetoExpInfoDirtyState] =
    useState(getExperimentInfoIsDirty());

  const productEdition = useProductEdition();
  const [generateRequired, setGenerateRequired] = useState(false);
  const dispatch = useRMDispatch();
  const exp = useRMSelector((state) => state.experiment.expData);
  const rmLite = useRMLite();
  const { plateWidth, plateHeight } = usePlateSize();
  usePlatesImagesStructureData();

  /*  Just a Hack for now, we need to remove this gloabl variable entirely
   */
  useEffect(() => {
    experimentData = cloneDeep(exp);
  }, [exp?.plateDto]);

  function Create2DArray(rows) {
    const arr = [];

    for (let i = 0; i < rows; i++) {
      arr[i] = [];
    }

    return arr;
  }

  SetRectCounter(0);

  function setImageView() {
    loadingDetails.push(ELoadingTypes.Images);
    setRefresh(true);
    view = 'Image';
    SetDisplayMode(DisplayModes.IMAGE);
    loadingDetails = loadingDetails.filter((ld) => ld != ELoadingTypes.Images);
    setRefresh(true);
  }

  async function setIngredientView() {
    loadingDetails.push(ELoadingTypes.Loading);
    setRefresh(true);
    view = 'Design';
    SetDisplayMode(DisplayModes.DESIGN);
    loadingDetails = loadingDetails.filter((ld) => ld != ELoadingTypes.Loading);
    setRefresh(true);
  }

  async function setScoreView() {
    if (!isScoringFeatureEnabled(productEdition)) {
      return;
    }
    loadingDetails.push(ELoadingTypes.Loading);
    setRefresh(true);
    view = 'Score';
    SetDisplayMode(DisplayModes.SCORE);
    loadingDetails = loadingDetails.filter((ld) => ld != ELoadingTypes.Loading);
    setRefresh(true);
  }

  function setExperimentMode(val) {
    switch (val) {
      case 'Design':
        if (view !== 'Design') {
          setIngredientView();
        }
        props.changeHeader('showDesign');
        break;
      case 'Images':
        if (view !== 'Images') {
          setImageView();
        }
        props.changeHeader('showImage');
        break;
      case 'Score':
        if (view !== 'Score') {
          setScoreView();
        }
        SetDisplayMode(DisplayModes.SCORE);
        props.changeHeader('showScore');
        break;
      case 'WellIngredient':
        props.changeHeader('showWellIngredient');
        break;
      default:
        break;
    }
    setRefresh(true);
  }

  useEffect(() => {
    async function updateFirstLoadDetails() {
      if (exp === null || exp === undefined) {
        return null;
      }
      props.setScoreViewRef(setScoreView);
      recentExpID = expid;
      experimentData = cloneDeep(exp) as ExperimentDtoClient;
      if (experimentData === undefined) {
        return;
      }
      /**
       * RFR-TODO: rename setPlateSizeRedux to setPlateSize after removing the local setPlateSize
       * function and replacing all its references with the reducer function
       */
      dispatch(setPlateSizeRedux({ plateWidth, plateHeight }));
      const wellinfo = Create2DArray(exp.colCount * exp.rowCount);

      if (exp.plateDto[0] === undefined) {
        return;
      }

      for (let plateNum = 0; plateNum < exp.colCount * exp.rowCount; plateNum++) {
        for (
          let wellNum = 0;
          wellNum < exp.plateDto[0].rows * exp.plateDto[0].cols;
          wellNum++
        ) {
          wellinfo[plateNum][wellNum] = null;
        }
      }
      if (
        (experimentData?.isImageModeActive &&
          productEdition !== EProductEditions.ExperimentDesigner) ||
        rmLite
      ) {
        props.changeTabMode(DisplayModes.IMAGE);
      } else {
        props.changeTabMode(DisplayModes.DESIGN);
      }
      ReactTooltip.hide();
      return exp;
    }

    if (recentExpID !== expid || redrawCanvasDuetoExpInfoDirtyState) {
      setRedrawCanvasDuetoExpInfoDirtyState(false);
      updateFirstLoadDetails();
    }
  }, [exp, redrawCanvasDuetoExpInfoDirtyState, plateWidth, plateHeight]);

  useEffect(() => {
    if (plateWidth && plateHeight) {
      dispatch(setPlateSizeRedux({ plateWidth, plateHeight }));
    }
  }, [plateWidth, plateHeight]);

  useEffect(() => {
    async function updateExpDetails() {
      const { exp } = props;
      if (exp === null || exp === undefined) {
        return null;
      }
      experimentData = exp;
      setRefresh(true);
    }
    if (props.isStateUpdated()) {
      updateExpDetails();
    }
  }, [props.stateUpdated]);
  useEffect(() => {
    if (experimentData === undefined) {
      return;
    }
    const displayMode = GetDisplayMode();
    if (displayMode === DisplayModes.DESIGN) {
      setExperimentMode('Design');
    } else if (displayMode === DisplayModes.IMAGESCORE) {
      setExperimentMode('Scoring');
    } else if (
      displayMode === DisplayModes.IMAGE ||
      displayMode === DisplayModes.WELLIMAGE
    ) {
      setExperimentMode('Images');
    } else if (displayMode === DisplayModes.WELLINGREDIENT) {
      setExperimentMode('WellIngredient');
    } else if (displayMode === DisplayModes.SCORE) {
      setExperimentMode('Score');
    } else {
      setExperimentMode('Design');
    }
  }, [props.selectedTabName]);

  function getLoadingDetails() {
    const isSavingState = loadingDetails.find((ld) => ld === ELoadingTypes.Saving);
    if (!isNullOrUndefined(isSavingState)) {
      return ELoadingTypes.Saving;
    }
    if (loadingDetails.length > 0) {
      props.setIsExperimentLoaded(false);
      return 'Loading...';
    } else {
      !props.isExperimentLoaded && props.setIsExperimentLoaded(true);
    }
  }

  if (refresh) {
    setRefresh(false);
  }

  if (!experimentData?.plateDto?.length) {
    return (
      <div
        id="experiment-loading-wrapper"
        style={{ display: 'flex', height: '100%', minWidth: '60%' }}
      >
        {' '}
        Loading Experiment...
      </div>
    );
  }

  if (isNullOrUndefined(experimentData)) {
    return null;
  }
  return (
    <>
      <div
        id="experiment-main-container"
        style={{
          display: 'flex',
          height: '100%',
          minWidth: '100%',
        }}
      >
        <div
          id="experiment-inner-container"
          style={{
            minWidth: `${props.w}`,
            display: 'flex',
          }}
        >
          <LoadingModal
            showModal={loadingDetails.length !== 0}
            text={getLoadingDetails()}
          />

          <ExperimentCanvas
            expid={expid}
            widthMainDiv={props.widthMainDiv}
            selectedTab={selectedTab}
            setCanvasRefs={props.setCanvasRefs}
            loadingDetails={loadingDetails}
            canvasWidth={props.canvasWidth}
            canvasHeight={canvasHeight}
            openedSideBars={props.openedSideBars}
            isLayerDrawingMode={props.isLayerMode}
            setZoomInvocker={props.setZoomInvocker}
            selectedTabName={props.selectedTabName}
            drawingLayerType={props.drawingLayerType}
            changeShowLayers={props.changeShowLayers}
            setRefresh={setRefresh}
            showOptimize={props.showOptimize}
            setShowOptimize={props.setShowOptimize}
            reportType={props.reportType}
            setReportType={props.setReportType}
            generateRequired={generateRequired}
            setGenerateRequired={setGenerateRequired}
            setSelectedSidePanelTab={props.setSelectedSidePanelTab}
          />
        </div>
      </div>
    </>
  );
}

export default Experiment;

export const setPlateSize = (
  exp: ExperimentDtoClient,
  plateWidth: number,
  plateHeight: number,
) => {
  exp.plateDto.forEach((plate) => {
    plate.startX =
      plateWidth * (plate.colPos - 1) + (GetPlatePadding() / 2) * plate.colPos;
    plate.startY =
      plateHeight * (plate.rowPos - 1) + (GetPlatePadding() / 2) * plate.rowPos;
    plate.availableWidth = plateWidth;
    plate.availableHeight = plateHeight;
    plate.width = plateWidth;
    plate.height = plateHeight;
    plate.stx = 0;
    plate.sty = 0;
    plate.endx = exp.containerCols;
    plate.endy = exp.containerRows;
    // after each plates new widht height r set then calculate wellrects which will be used by renderers etc down the tree
    InitWellRects(plate, exp.containerRows, exp.containerCols);
  });
};

export const getExperimentPlateSize = (exp: ExperimentDtoClient) => {
  return getPlateSize(
    WIDTH_MAIN_DIV,
    exp.rowCount,
    exp.colCount,
    exp.containerRows,
    exp.containerCols,
  );
};
